<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="[
        'Período',
        'Nível de Risco',
        'Risco Limite CRL',
        'Data Aprovação CRL',
        'Data Vigência CRL',
        'Qte Operações CRL',
        'Valor Concedido CRL',
        'Valor Disponível CRL',
        'Valor Utilizado CRL',
        'Patrimônio de Referência',
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.periodoMovimento ? obj.periodoMovimento  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.nivelRiscoCliente ? obj.nivelRiscoCliente  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.nivelRiscoLimiteCRL ? obj.nivelRiscoLimiteCRL  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.dataAprovarcaoCRL ? formatDate(obj.dataAprovarcaoCRL)  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.dataVigenciaCRL ? formatDate(obj.dataVigenciaCRL)  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.quantidadeOperacoesClienteCRL ? parseInt(obj.quantidadeOperacoesClienteCRL).toString()  : '0'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.valorConcedidoCRL ? formatValue(parseInt(obj.valorConcedidoCRL))  : 'R$ 0,00'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.valorDisponivelCRL ? formatValue(parseInt(obj.valorDisponivelCRL))  : 'R$ 0,00'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.valorUtilizadoCRL ? formatValue(parseInt(obj.valorUtilizadoCRL))  : 'R$ 0,00'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.patrimonioReferencia ? formatValue(parseInt(obj.patrimonioReferencia))  : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import RiscoRepository from '@/shared/http/repositories/business/risco.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'debitRisc',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadAssociateRisc(this.document)
      }
    },
    onLoadAssociateRisc (document) {
      loading.push()
      this.document = document
      RiscoRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    showLead (obj) {
      if (obj) {
        const routeData = this.$router.resolve({
          name: 'DetalhesLead',
          params: {
            boardId: obj.boardColumn.board.id,
            cardId: obj.id
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/debitRisc.vue